<ion-content
  class="valuePickerModal"
  [class.valuePickerModal--left]="!alignRight"
  [class.valuePickerModal--right]="alignRight"
  [class.valuePickerModal--noGradient]="noGradient"
  (click)="closeModal()"
  color="transparent"
  [attr.uid]="uid"
>
  <div class="valuePickerModal__list">
    <ion-list>
      @for (value of values; track value) {
        <ion-item
          button
          class="valuePickerModal__item"
          lines="none"
          [attr.uid]="'valuePickerItem--' + value.value"
          [color]="value.value === selected?.value ? 'primary' : null"
          [disabled]="value.disabled"
          (click)="onSelected(value, $event)"
        >
          <ion-label class="valuePickerModal__label">{{ value.label }}</ion-label>
        </ion-item>
      }
    </ion-list>
  </div>
</ion-content>
